// extracted by mini-css-extract-plugin
var _1 = "d0hlz";
var _2 = "b2Pm2";
export { _1 as "list", _2 as "loading" }
